import type { JSX } from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { SortableTableHeaders } from '@/shared/components/SortableTableHeaders';
import type { SortState } from '@/shared/types/table-filters.types';
import type { Company } from '../types/company.types';
import { CompanyRow } from './CompanyRow';

export interface CompanyTableProps {
  companies: Company[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  onEdit: (company: Company) => void;
  onActivate?: ((id: string) => void) | undefined;
  onSuspend?: ((id: string) => void) | undefined;
  onEnterCompany?: ((company: Company) => void) | undefined;
  showStatusActions?: boolean | undefined;
}

const SORTABLE_HEADERS = [
  { key: 'name', label: 'Company', className: 'w-[250px]' },
  { key: 'industry', label: 'Industry' },
  { key: 'location', label: 'Location' },
  { key: 'companySize', label: 'Size' },
  { key: 'status', label: 'Status' },
];

export function CompanyTable({
  companies,
  sort,
  onToggleSort,
  showStatusActions = false,
  ...rowHandlers
}: CompanyTableProps): JSX.Element {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <SortableTableHeaders
              headers={SORTABLE_HEADERS}
              sort={sort}
              onToggleSort={onToggleSort}
            />
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {companies.map((company) => (
            <CompanyRow
              key={company.id}
              company={company}
              showStatusActions={showStatusActions}
              {...rowHandlers}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
